<template>
  <v-layout
    v-if="!!timeframes && timeframes.length > 0"
    v-bind="layout"
    :class="[marginClass]"
  >
    <v-layout
      v-for="(timeframe, timeframeIndex) of timeframes"
      :key="timeframe.id + timeframeIndex"
      class="pb-1"
      :class="{'mr-2': horizontal}"
      style="overflow: hidden"
    >
      <v-icon
        v-if="showIcon && $vuetify.breakpoint.smAndUp"
        color="msr"
        style="margin-right: 6px"
        small
      >
        timelapse
      </v-icon>
      <v-layout
        column
        class="msr--text"
      >
        <div
          v-if="timeframe.name"
          class="caption"
        >
          {{ timeframe.name }}
        </div>
        <div
          class="grey--text text--darken-2 nowrap"
          style="font-size: 66%"
          :style="{
            'font-size': !timeframe.name ? '100%' : '66%',
            'line-height': !timeframe.name ? 'initial' : 1,
          }"
        >
          {{ describeWeekdays(timeframe.weekdays) }},
          {{ `${timeframe.start} - ${timeframe.end}` }}
        </div>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import {describeWeekdays} from '@/mixins/weekdays';

export default {
  props: {
    timeframes: {
      type: Array[Object],
      required: true,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    marginClass: {
      type: String,
      default: 'mt-1',
    },
  },
  computed: {
    layout() {
      if (!this.horizontal) {
        return {column: true};
      }
      return {row: true};
    },
  },
  methods: {
    describeWeekdays: describeWeekdays,
    isCrossingMidnight(timeframe) {
      return timeframe && timeframe.start > timeframe.end;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/EntryTimeframe.vue